import { Injectable, signal } from '@angular/core'

@Injectable({
    providedIn: 'root',
})
export class MenuDrawerStateService {
    visible = signal(false)

    open() {
        this.visible.set(true)
    }

    close() {
        this.visible.set(false)
    }

    toggle() {
        this.visible.update((v) => !v)
    }
}
